import { AllianzAccountReportEntity } from '../entities/allianz-account-report-entity';

export default class State {
  loaded = false;

  is_loading = false;

  items: Array<AllianzAccountReportEntity> = [];
}
